module.exports = __webpack_public_path__ + "img/store4.2937da6f.png";